import { render } from "./default.vue?vue&type=template&id=607f2110&scoped=true&bindings={\"areaClientiLink\":\"options\",\"viewportHeight\":\"options\",\"transitionName\":\"options\",\"nextPage\":\"options\",\"prevPage\":\"options\",\"isHelp\":\"options\",\"dynamicClasses\":\"options\",\"getAdjacentRoute\":\"options\",\"navigate\":\"options\",\"manageWheel\":\"options\"}"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"

import "./default.vue?vue&type=style&index=0&id=607f2110&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-607f2110"

export default script